module.exports = __webpack_public_path__ + "static/media/white-paper-image.981ddbde.png";